var frontSelect2 = function() {
    var handleSelectSearchRemote = function() {
        var ele = $(".select_search_remote");

        function formatResult(data) {
            var markup = "<table class='search-result'><tr>";

            if (data.loading == true) return 'Đang tìm...';
            if (data.image !== undefined && data.image) {
                markup += "<td valign='top'><img class='product-image' src='" + publicPath + '/uploads/products/' + data.image + "'/></td>";
            }

            markup += "<td valign='middle' class='search-block-right'><div class='product-name'>" + data.name;
            if (data.code != '') {
                markup += " (<strong>" + data.code + "</strong>)";
            }
            markup += "</div><div class='search-price'>";
            if (data.sale_price > 0) {
                markup += '<del>' + vn_money_format(data.price) + '</del>&emsp;<span>' + vn_money_format(data.sale_price) + '</span>';
            } else {
                markup += '<span>' + vn_money_format(data.price) + '</span>';
            }
            markup += "</div></td></tr></table>";
            return markup;
        }

        function vn_money_format(money) {
            money += '';
            money = money.replace('.00', '');
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(money)) {
                money = money.replace(rgx, '$1' + '.' + '$2');
            }
            return money + 'đ';
        }

        ele.select2({
            minimumInputLength: 1,
            ajax: {
                url: basePath + '/ajax/front-search',
                cache: true,
                quietMillis: 300,
                data: function (params) {
                    return {
                        keyword: params.term,
                    };
                },
                processResults: function (data, params) {
                    return {
                        results: data.data
                    };
                }
            },
            templateResult: formatResult,
            templateSelection: function(selected_item) {
                location.href = selected_item.url;
            },
            escapeMarkup: function (m) {
                return m;
            },
            language: {
                inputTooShort: function(args) {
                    return "Vui lòng nhập ít nhất 1 ký tự";
                },
                inputTooLong: function(args) {
                    return "Quá nhiều ký tự cho phép";
                },
                errorLoading: function() {
                    return "Bạn nhập quá nhanh";
                },
                noResults: function() {
                    return "Không tìm thấy dữ liệu";
                },
                searching: function() {
                    return "Đang tìm...";
                },
                maximumSelected: function(args) {
                    return "Lỗi không lấy được dữ liệu";
                }
            }
        });
    };

    return {
        init: function() {
            handleSelectSearchRemote();
        }
    }
}();

$(document).ready(function() {
    frontSelect2.init();

    $('body').on('keypress', '.integer', function (event) {
        if ((event.which != 46 || $(this).val().indexOf('.')  < 0) && (event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });
    $('.has-maxlength').maxlength({
        alwaysShow: true
    });
    $('.add-cart').click(function() {
        $(
            '<form action="/cart/add" method="POST">' +
            '<input type="hidden" name="_token" value="' + $('meta[name=_token]').attr('content') + '">' +
            '<input type="hidden" name="id" value="' + $(this).attr('data-id') + '">' +
            '<input type="hidden" name="qty" value="1">' +
            '</form>'
        ).appendTo('body').submit();
    });
});

function vn_money_format(money) {
    money += '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(money)) {
        money = money.replace(rgx, '$1' + '.' + '$2');
    }
    return money;
}